import type { NewsletterFormSection } from "@/modules/corporate/types/sections"
import type { FunctionComponent } from "react"

import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"

import { Card } from "@/modules/corporate/components/Card/Card"
import { NewsletterContact } from "@/modules/corporate/components/Forms/NewsletterContact"

export type NewsletterFormPropsType = {
  section: NewsletterFormSection
}

export const NewsletterForm: FunctionComponent<NewsletterFormPropsType> = ({ section }) => {
  return (
    <Layout hasTopPadding hasBottomPadding>
      <Layout.Column>
        <Card title={section.title} richDescription={section.description} theme="purple">
          <NewsletterContact
            actionUrl={section.url}
            buttonTitle={section.buttonTitle}
            successMessage={section.successMessage}
          />
        </Card>
      </Layout.Column>
    </Layout>
  )
}
